import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { promoCodes } from 'src/constants/promoCodes'
import { commonTitleText } from 'src/modules/utils/constants'

export default (props) => {
  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      title={commonTitleText.streamLiveTVSports}
      subtitle={
        <>
          {' '}
          Enjoy a Special Offer through Shall I Stream It? <br /> Save $30 on your first month of
          Fubo
        </>
      }
      offerCode={promoCodes.shall_i_stream_it}
      noIndex={true}
    />
  )
}
